<template>
  <!--页面加载动画-->
  <div class="authBtnBox" @click.stop="show = false">
    <van-popup v-model="show" :close-on-click-overlay="false" round position="center">
      <div class="comfirm-box">
        <div class="comfirm-title">提示</div>
        <div class="comfirm-content" v-html="text"></div>
        <div class="comfirm-btns">
          <div class="btn" @click.stop="noAuth">暂不授权</div>
          <div class="btn active" @click.stop="authLogin">同意授权</div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  data() {
    return {
      show: false
    };
  },
  props: ['text'],
  mounted() {
    if (this.$tools.isWeiXin() && !localStorage.bdgj_openid && !sessionStorage.ignoreLogin) {
      this.show = true;
    }
  },
  methods: {
    // 同意授权
    authLogin() {
      this.$weixin.jumpAuth();
    },
    //暂不授权
    noAuth() {
      this.$emit('close');
      if (!this.forceAuth) {
        sessionStorage.ignoreLogin = true;
        this.show = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.authBtnBox {
  .authBtn {
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 10;
    left: 0;
    top: 0;
  }

  .comfirm-box {
    color: #000;
    width: 690px;
    padding: 20px 45px;
    .comfirm-title {
      font-size: 34px;
      font-weight: 700;
      color: #000000;
      padding: 20px 0px;
      text-align: center;
    }
    .comfirm-content {
      font-size: 30px;
      color: #3c464f;
      line-height: 48px;
      font-weight: 500;
    }

    .comfirm-btns {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 60px;
      padding-bottom: 40px;
      .btn {
        font-weight: 500;
        width: 290px;
        height: 80px;
        border-radius: 45px;
        border: 1px solid #236dff;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 32px;
        color: #236dff;
        &.active {
          background: #236dff;
          color: #fff;
        }
      }
    }
  }
}
</style>
